/**
 * Hero sections with section.index > 1 use preload="none" (see hero.liquid).
 * Hydrates muted autoplay loop videos when they near the viewport.
 */
(function () {
  const queryAllRoots = (selector) => {
    const results = [];
    const seen = new WeakSet();

    const collect = (root) => {
      if (!root || seen.has(root)) return;
      seen.add(root);

      if (typeof root.querySelectorAll !== 'function') return;
      root.querySelectorAll(selector).forEach((node) => results.push(node));
      root.querySelectorAll('*').forEach((node) => {
        if (node.shadowRoot) collect(node.shadowRoot);
      });
    };

    collect(document);
    return results;
  };

  const fixSeoLinkText = () => {
    queryAllRoots('a[href*="/pages/cookie-policy"]').forEach((link) => {
      if (link.textContent.trim().toLowerCase() !== 'learn more') return;
      link.textContent = 'Learn more about our cookie policy';
      link.setAttribute('aria-label', 'Learn more about our cookie policy');
    });
  };

  const fixVideoFallbackAlts = () => {
    queryAllRoots('video.hero__media > img:not([alt])').forEach((image) => {
      image.alt = '';
    });
  };

  const fixSeoAuditNodes = () => {
    fixSeoLinkText();
    fixVideoFallbackAlts();
  };

  fixSeoAuditNodes();

  if ('MutationObserver' in window) {
    const seoObserver = new MutationObserver(fixSeoAuditNodes);
    seoObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  const videos = document.querySelectorAll('video.hero__media[preload="none"]');
  if (!videos.length) return;

  const hydrate = (video) => {
    if (video.dataset.topshelfLazyHydrated) return;
    video.dataset.topshelfLazyHydrated = 'true';
    video.preload = 'auto';
    video.load();
    const p = video.play?.();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(hydrate);
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      }
    },
    { rootMargin: '280px 0px', threshold: 0.01 }
  );

  videos.forEach((v) => io.observe(v));
})();

/**
 * The desktop cart drawer is non-modal so shoppers can continue browsing.
 * Close it when a click lands anywhere outside the drawer. Mobile backdrop
 * clicks remain handled by the theme drawer itself.
 */
(function initTopshelfCartDrawerOutsideClick() {
  if (window.__topshelfCartDrawerOutsideClickBound) return;
  window.__topshelfCartDrawerOutsideClickBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const drawer = document.querySelector('#cart-drawer[open]');
      if (!(drawer instanceof HTMLElement)) return;

      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      if (path.includes(drawer) || drawer.contains(event.target)) return;

      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('[aria-controls="cart-drawer"]')) return;

      if (typeof drawer.close === 'function') drawer.close();
    },
    true
  );
})();
